import * as React from 'react';
import {Layer, Source, useMap} from 'react-map-gl/maplibre';

import {FC, useEffect, useMemo, useState} from 'react';
import {ImageSourceSpecification, RasterLayerSpecification} from '@maplibre/maplibre-gl-style-spec';


const _convertTo3857 = (lng: number, lat: number) => {
  const x = lng * 20037508.34 / 180;
  const y = Math.log(Math.tan((90 + lat) * Math.PI / 360)) / (Math.PI / 180);
  const yMercator = y * 20037508.34 / 180;

  return {x: x, y: yMercator};
};

const _catastroSource = (
  [[xMin, yMin], [xMax, yMax]]: [number, number][], //bbox
  [_width, _height]: [number, number], //size
  transparent: boolean
): ImageSourceSpecification => {

  const {x: xMinMercator, y: yMinMercator} = _convertTo3857(xMin, yMin);
  const {x: xMaxMercator, y: yMaxMercator} = _convertTo3857(xMax, yMax);

  return {
    type: 'image',
    url: 'https://ovc.catastro.meh.es/Cartografia/WMS/ServidorWMS.aspx?' +
      'service=WMS&' +
      'version=1.1.0&' +
      'request=GetMap&' +
      'layers=catastro&' +
      `format=${transparent ? 'image/png': 'image/jpeg'}&` +
      `transparent=${transparent}&` +
      'srs=EPSG:3857&' +
      `bbox=${xMinMercator},${yMinMercator},${xMaxMercator},${yMaxMercator}&` +
      `width=${_width}&` +
      `height=${_height}`,
    coordinates: [
      [xMin, yMax],
      [xMax, yMax],
      [xMax, yMin],
      [xMin, yMin],
    ]
  };
};

type CatastroLayerProps = {
  beforeId?: string,
  transparent?: boolean
};

const CatastroLayer: FC<CatastroLayerProps> = ({beforeId, transparent = true}) => {

  const {current: map} = useMap();
  const [canvasBounds, setCanvasBounds] = useState<[number, number][] | undefined>(undefined);
  const [canvasSize, setCanvasSize] = useState<[number, number] | undefined>(undefined);
  useEffect(() => {
    console.log('Setting up CatastroLayer');
    const callback = () => {
      if (map) setCanvasBounds(map.getBounds().toArray());
      if (map) setCanvasSize([map.getCanvas().width, map.getCanvas().height]);
    };

    if (map) {
      map.on('idle', callback);
      callback();
      console.log('Set up CatastroLayer');
    }
    
    return () => {
      if (map) map.off('idle', callback);
    };
  }, [map]);

  const source = useMemo(() => 
    canvasBounds && canvasSize && _catastroSource(canvasBounds, canvasSize, transparent),
  [canvasBounds, canvasSize, transparent]);

  const layerStyle: RasterLayerSpecification = {
    id: 'catastro',
    type: 'raster',
    source: 'catastro',
    paint: {
      'raster-opacity': 1
    }
  };

  if (!source) return <></>;

  return <Source id="catastro" {...source}>
    <Layer {...layerStyle} beforeId={beforeId} />
  </Source>;
};

export default CatastroLayer;